import React, { useState } from 'react';
import styled from 'styled-components';
import { typeStyle, mediaQuery } from '@carvana/showroom-css-theme';

import Dropdown, { DropdownItem } from './Dropdown';
import { Carrot } from './icons';

type NavItemProps = {
  label: string;
  href: string;
  childItems?: Array<DropdownItem>;
};

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
  padding: 24px 32px;
  justify-content: space-between;
  flex-direction: column;
  align-items: baseline;
  ${mediaQuery('l')} {
    padding: 0;
    flex-direction: row;
  }
`;

const NavLink = styled.a`
  width: auto;
  display: flex;
  justify-content: space-between;
  gap: 4px;
  :hover {
    text-decoration: none;
  }
`;

const NavLabel = styled.p<{ isActive: boolean }>`
  ${typeStyle('label-m')};
  margin: 0;
  color: var(--cvna-color-blue-6);
  border-bottom: 4px solid;
  border-color: ${({ isActive }) =>
    isActive ? 'var(--cvna-color-blue-2)' : 'transparent'};
  transition: color 150ms ease-in-out;
  :hover {
    text-decoration: none;
    color: var(--cvna-color-blue-2);
  }
`;

const NavItem: React.FC<NavItemProps> = ({ label, href, childItems }) => {
  let pathname = '';
  if (typeof window !== 'undefined') {
    pathname = window.location.pathname;
  }

  const hasChildren = Boolean(childItems && childItems.length);
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <ItemContainer tabIndex={0} onMouseEnter={open} onMouseLeave={close}>
      <NavLink href={href}>
        <NavLabel isActive={pathname === href}>{label}</NavLabel>
        {hasChildren && <Carrot direction={isOpen ? 'down' : 'up'} />}
      </NavLink>
      {hasChildren && isOpen && <Dropdown items={childItems || []} />}
    </ItemContainer>
  );
};

NavItem.defaultProps = {
  childItems: []
};

export default NavItem;
